<template>
  <div class="main-home">
    Dashboard
  </div>
</template>

<script>
  export default {
    name: "Home",
    components: {},
    mounted() {
      this.checkLogin();
    },
    methods: {
      checkLogin() {
        this.$http.get("basic", "account/checkLogin");
      },
    },
  };
</script>

<style lang="scss" scoped>
  .main-home {
    text-align: center;
    font-size: 20px;
  }
</style>
